/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Reviewer_TitleInputs */

const en_mk_team_reviewer_title = /** @type {(inputs: Mk_Team_Reviewer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A read-only Reviewer`)
};

const id_mk_team_reviewer_title = /** @type {(inputs: Mk_Team_Reviewer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemeriksa yang hanya membaca`)
};

/**
* | output |
* | --- |
* | "A read-only Reviewer" |
*
* @param {Mk_Team_Reviewer_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_reviewer_title = /** @type {((inputs?: Mk_Team_Reviewer_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Reviewer_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_reviewer_title(inputs)
	return en_mk_team_reviewer_title(inputs)
});